import React, { useState } from "react";
import { Button, Box, TextField } from "@mui/material";
import { getRandomShoes } from "../services/api";
import SinglePatternTable from "./SinglePatternTable";


const Game = () => {
  const [loading, setLoading] = useState(false);
  const [nextHand, setNextHand] = useState(1);
  const [searchResults, setSearchResults] = useState(null);
  const [totalHand, setTotalHand] = useState(null);
  const [inputData, setInputData] = useState(""); // New state for input data
  const [inputError, setInputError] = useState(false); // State for input validation

  // Handle the input field change
  const handleInputChange = (event) => {
    const value = event.target.value;

    // Ensure only numbers or empty input are accepted
    if (value === "" || /^[0-9]*$/.test(value)) {
      setInputData(value);
      setInputError(false); // Reset error state on valid input
    } else {
      setInputError(true); // Set error if input is not a valid number
    }
  };

  // Fetch new data with input data (send empty string if input is empty or invalid)
  const handleGetShoe = () => {
    if (inputError) {
      return; // Do nothing if there is an input error
    }

    // Check if the inputData is within the valid range (1 to 25000)
    const inputNumber = parseInt(inputData, 10);
    if (inputData !== "" && (inputNumber < 1 || inputNumber > 25000)) {
      setInputError(true); // Set error if the input is out of range
      return;
    }

    setLoading(true);
    // Pass the input data (empty string if input is empty or invalid)
    getRandomShoes(inputData || "")
      .then((response) => {
        setSearchResults(response);
        setTotalHand(response.totalHands);
        setNextHand(1); // Reset nextHand to 1 when fetching new data
      })
      .catch((error) => {
        console.error("Error occurred while fetching data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleNextHand = () => {
    if (searchResults && nextHand <= totalHand) {
      setNextHand((prev) => prev + 1);
    }
  };

  return (
    <div>
      {/* Input field for user data */}
      <Box display="flex" justifyContent="center" gap={2} mb={3}>
      <TextField
        label="Enter a Shoe No"
        variant="outlined"
        value={inputData}
        onChange={handleInputChange}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            handleGetShoe(); // Trigger New Game button on Enter
          }
        }}
        size="small"
        error={inputError} // Show error if invalid input
        helperText={inputError ? "Please enter a valid Shoe No [1 - 25000]" : ""}
        sx={{
          width: "200px", // Set width of input field
        }}
      />
      </Box>

      {/* Buttons at the Top Middle */}
      <Box display="flex" justifyContent="center" gap={2} mb={3}>
        <Button
          variant="contained"
          size="large"
          sx={{
            backgroundColor: "#495057", // Dark gray color
            color: "white", // Text color to ensure good contrast
            px: 4,
            py: 2,
          }}
          onClick={handleGetShoe}
          disabled={loading || inputError} // Disable if loading or input has error
        >
          New Game
        </Button>
        <Button
          variant="contained"
          size="large"
          sx={{
            backgroundColor: "#6c757d", // Dark gray color
            color: "white", // Text color to ensure good contrast
            px: 4,
            py: 2,
          }}
          onClick={handleNextHand}
          disabled={!searchResults || nextHand >= totalHand}
        >
          Next Hand ({nextHand})
        </Button>
      </Box>

      {/* Show SinglePatternTable only for the current nextHand */}
      {searchResults &&
        Object.entries(searchResults.dataAll).map(([key, value], index) => (
          <SinglePatternTable
            key={index}
            data={value}
            shoeDataAll={searchResults.shoeDataAll[key]}
            nextHand={nextHand}
          />
        ))}
    </div>
  );
};

export default Game;
